import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Button from '@material-ui/core/Button';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';

export default function PushSettings__Default(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [translateGui] = useGuiTranslations();

    const enableButtonClick = () => {
        //window.OneSignal.showNativePrompt();
        window.OneSignal.registerForPushNotifications();
    }

    return (
        <div className={classes.root}>
            <div className={classes.wrapper}>
                <div className={classes.messageDiv}>
                {capitalizeFirstLetter(translateGui(128))}
                </div>
                <div className={classes.buttonWrapper}>
                    <Button color="primary" variant="contained" onClick={() => enableButtonClick()}>{capitalizeFirstLetter(translateGui(127))}</Button>
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    root: {
      display:'flex',
      justifyContent: 'center',  
    },
    messageDiv:{
        margin: '30px 0',
    },
    wrapper:{
        width: '80%',
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
    },

});